import { Logo } from './Logo'
import { appSettings } from '../../../config/app-settings'

// Brand lockup: the logo mark and the "QuickScore" wordmark on one baseline. The `.logo`
// rules (assets/css/style.css) size the mark (`.logo img`) and style the wordmark
// (`.logo span` — ink, Nunito); `d-flex align-items-center` keeps them vertically centred.
export const LogoWithName = () => {
  return (
    <a href="/" className="logo d-flex align-items-center">
      <Logo />
      <span>{appSettings.CompanyName}</span>
    </a>
  )
}
